import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { DashboardEditable as AVPDashboardEditable } from '@atlassian/jsm-enterprise-reports-common/src/ui/new-avp-experience/dashboard-editable/index.tsx';
import { usePathParam, Redirect } from '@atlassian/react-resource-router';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import type { AssetsReportsV2Props } from '../../common/types.tsx';
import { getHostingProduct } from '../../common/utils.tsx';
import { PreferenceBanner } from '../../common/ui/preference-banner/index.tsx';

export const DashboardEditable = ({ workspaceId }: AssetsReportsV2Props): React.JSX.Element => {
	const [slug] = usePathParam('templateId');
	const cloudId = useCloudId();
	if (!slug) {
		return <Redirect to="/jira/servicedesk/assets/reports" />;
	}
	return (
		<>
			<PreferenceBanner />
			<Box xcss={dashboardEditableWrapper}>
				<AVPDashboardEditable
					hostingProduct={getHostingProduct()}
					slug={slug}
					workspaceId={workspaceId}
					allowGlobalFilters
					cloudId={cloudId}
				/>
			</Box>
		</>
	);
};

const dashboardEditableWrapper = xcss({
	marginLeft: 'space.400',
	marginRight: 'space.400',
});
